import { render, staticRenderFns } from "./ConfirmResetPassword.vue?vue&type=template&id=4d245d8b&scoped=true"
import script from "./ConfirmResetPassword.vue?vue&type=script&lang=js"
export * from "./ConfirmResetPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d245d8b",
  null
  
)

export default component.exports